// Copied from GBC ecosystem — do not rewrite, keep in sync

const CALLING_CODES: [string, string][] = [
  ['886','TW'],['880','BD'],['856','LA'],['855','KH'],['853','MO'],['852','HK'],
  ['998','UZ'],['996','KG'],['995','GE'],['994','AZ'],['993','TM'],['992','TJ'],
  ['977','NP'],['976','MN'],['975','BT'],['974','QA'],['973','BH'],['972','IL'],
  ['971','AE'],['968','OM'],['967','YE'],['966','SA'],['965','KW'],['964','IQ'],
  ['963','SY'],['962','JO'],['961','LB'],['960','MV'],
  ['423','LI'],['421','SK'],['420','CZ'],
  ['389','MK'],['387','BA'],['386','SI'],['385','HR'],['382','ME'],['381','RS'],
  ['380','UA'],['377','MC'],['376','AD'],['375','BY'],['374','AM'],['373','MD'],
  ['372','EE'],['371','LV'],['370','LT'],
  ['359','BG'],['358','FI'],['357','CY'],['356','MT'],['355','AL'],['354','IS'],
  ['353','IE'],['352','LU'],['351','PT'],
  ['263','ZW'],['260','ZM'],['256','UG'],['255','TZ'],['254','KE'],['234','NG'],
  ['221','SN'],['220','GM'],['218','LY'],['216','TN'],['213','DZ'],['212','MA'],
  ['98','IR'],['95','MM'],['94','LK'],['93','AF'],['92','PK'],['91','IN'],
  ['90','TR'],['86','CN'],['84','VN'],['82','KR'],['81','JP'],
  ['66','TH'],['65','SG'],['64','NZ'],['63','PH'],['62','ID'],['61','AU'],['60','MY'],
  ['58','VE'],['57','CO'],['56','CL'],['55','BR'],['54','AR'],['53','CU'],
  ['52','MX'],['51','PE'],
  ['49','DE'],['48','PL'],['47','NO'],['46','SE'],['45','DK'],['44','GB'],
  ['43','AT'],['41','CH'],['40','RO'],['39','IT'],['36','HU'],
  ['34','ES'],['33','FR'],['32','BE'],['31','NL'],['30','GR'],
  ['27','ZA'],['20','EG'],
  ['7','RU'],['1','US'],
];

function iso2ToFlag(iso2: string): string {
  return [...iso2].map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65)).join('');
}

function formatIntlPhone(withPlus: string): string {
  const digits = withPlus.replace(/\D/g, '');
  const groups: string[] = [];
  let rem = digits;
  while (rem.length > 4) { groups.unshift(rem.slice(-4)); rem = rem.slice(0, -4); }
  if (rem) groups.unshift(rem);
  return '+' + groups.join(' ');
}

export function formatPhoneVN(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
}

export function getPhoneInfo(raw?: string): { flag: string; display: string } {
  const cleaned = (raw ?? '').replace(/\s/g, '');
  if (!cleaned) return { flag: '', display: '' };
  if (cleaned.startsWith('0')) return { flag: '🇻🇳', display: formatPhoneVN(cleaned) };
  const withPlus = cleaned.startsWith('+') ? cleaned : '+' + cleaned;
  const digits = withPlus.slice(1);
  for (const [prefix, iso2] of CALLING_CODES) {
    if (digits.startsWith(prefix)) return { flag: iso2ToFlag(iso2), display: formatIntlPhone(withPlus) };
  }
  return { flag: '🌐', display: formatIntlPhone(withPlus) };
}

export function toIntlTel(phone?: string): string {
  const p = (phone || '').replace(/\s/g, '');
  return p.startsWith('0') ? '+84' + p.slice(1) : p;
}

export function formatGuestPhone(raw: string): string {
  const trimmed = raw.trimStart();
  if (!trimmed) return '';
  if (trimmed.startsWith('+')) {
    const body = trimmed.slice(1).replace(/[^\d\s\-()]/g, '');
    return ('+' + body).replace(/\s{2,}/g, ' ').slice(0, 22);
  }
  if (trimmed.startsWith('0')) return formatPhoneVN(trimmed);
  return trimmed.replace(/[^\d\s\-+()]/g, '').slice(0, 22);
}

export function isValidGuestPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}

export function getOttChatUrl(appId: string, phone: string): string {
  const cleaned = phone.replace(/\s/g, '');
  if (!cleaned) return '';
  const intl = cleaned.startsWith('0') ? '+84' + cleaned.slice(1) : cleaned.startsWith('+') ? cleaned : '+' + cleaned;
  const noPlus = intl.slice(1);
  switch (appId) {
    case 'whatsapp':  return `https://wa.me/${noPlus}`;
    case 'zalo':      return `https://zalo.me/${cleaned.startsWith('0') ? cleaned : intl}`;
    case 'telegram':  return `https://t.me/${intl}`;
    case 'viber':     return `viber://chat?number=${encodeURIComponent(intl)}`;
    case 'imessage':  return `sms:${intl}`;
    case 'wechat':    return 'weixin://';
    case 'kakaotalk': return 'kakaotalk://';
    case 'line':      return `https://line.me/R/ti/p/${encodeURIComponent(intl)}`;
    default:          return '';
  }
}

export function copyText(text: string): void {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => execCopy(text));
  } else {
    execCopy(text);
  }
}

function execCopy(text: string): void {
  const el = document.createElement('textarea');
  el.value = text;
  el.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
  document.body.appendChild(el);
  el.focus();
  el.select();
  try { document.execCommand('copy'); } catch { /* silent */ }
  document.body.removeChild(el);
}

// ── Date utils ───────────────────────────────────────────

export function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Returns true if the string contains non-Latin characters (Arabic, Chinese, Cyrillic, etc.)
 *  Latin Extended Additional (U+1E00-U+1EFF) covers Vietnamese — treated as Latin. */
export function hasNonLatin(s: string): boolean {
  return /[^\u0300-\u036F\u0020-\u024F\u1E00-\u1EFF\s]/u.test(s);
}

// guestNationality bị 2 UI ghi 2 convention khác nhau (modal Sửa ghi code 'VN', panel Checklist NV ghi
// label tiếng Anh 'Vietnam'/'Vietnamese') — nhận diện cả hai để logic "khách Việt không cần tạm trú" đúng dù ghi từ đâu.
export function isVietnamNationality(nat?: string): boolean {
  if (!nat) return false;
  const n = nat.trim().toLowerCase();
  return n === 'vn' || n === 'việt nam' || n === 'viet nam' || n === 'vietnam' || n === 'vietnamese';
}

// Ký tự Latin có TỔ HỢP dấu đặc trưng RIÊNG tiếng Việt (vd ắ/ệ/ừ) → dùng để đoán "câu này đã là
// tiếng Việt, khỏi dịch". ⚠️ CỐ Ý KHÔNG dùng dấu đơn phổ biến (à/á/é/ê/ô/ù…) — dấu đơn trùng với
// tiếng Pháp/Bồ Đào Nha/Tây Ban Nha/Ý, nên 1 câu tiếng Pháp bình thường ("arrivé", "être") cũng bị
// nhận nhầm là tiếng Việt rồi bỏ qua dịch hoàn toàn — bug thật 2026-09-24 (NV Chi báo tin AI gửi
// khách bằng tiếng Pháp không hiện bản dịch VI, cả 2 bản copy cũ của regex này đều dính: đây +
// lib/translate-vi.ts). Tổ hợp 2 dấu (ắ/ầ/ệ/ừ…) hầu như không xuất hiện ở các ngôn ngữ Latin khác.
// (Bộ ký tự KHÔNG đầy đủ 100% tổ hợp tiếng Việt — vd thiếu ấ/ờ/ớ/ử/ữ — chấp nhận được: thiếu chỉ
// khiến 1 câu VI hiếm khi bị dịch lại lãng phí, ĐỠ HẠI hơn nhận nhầm ngôn ngữ khác thành VI.)
// Tiếng Việt thật LUÔN có ký tự có dấu — dùng làm lưới an toàn bắt AI trả nhầm ngôn ngữ (Haiku hay mirror ngôn ngữ khách
// dù prompt bảo viết tiếng Việt). Bộ ký tự ĐẦY ĐỦ, khác `appearsVietnamese` (chỉ bộ dấu đặc trưng, dùng để bỏ qua dịch).
const VI_DIACRITICS_RE = /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/i;
/** Câu đủ dài (>minLen) mà KHÔNG có ký tự có dấu tiếng Việt nào → gần như chắc chắn không phải tiếng Việt. */
export function looksNotVietnamese(text: string, minLen = 25): boolean {
  return text.length > minLen && !VI_DIACRITICS_RE.test(text);
}
export function hasVietnameseDiacritics(text: string): boolean { return VI_DIACRITICS_RE.test(text); }

// Ký tự RIÊNG tiếng Việt (không dùng trong Pháp/Tây Ban Nha/Bồ Đào Nha/Đức/Ý): ă ơ ư đ + dấu nặng/hỏi/ngã dưới nguyên âm
// đơn + mọi tổ hợp dấu chồng. CỐ Ý bỏ à á â ã é è ê ô õ ù … vì trùng ngôn ngữ khác.
const VI_STRONG_CHARS_RE = /[ăơưđạảẹẻẽịỉĩọỏụủũỳỷỹỵầấậẩẫằắặẳẵềếệểễồốộổỗờớợởỡừứựửữ]/i;

/**
 * Văn bản này CÓ PHẢI tiếng Việt không (dùng để bỏ qua dịch / nhận diện ngôn ngữ).
 * ⚠️ Phải xét TỶ LỆ từ chứ không "có 1 ký tự riêng là đủ": tin tiếng Pháp/Anh/... chứa 1 địa danh Việt ("Nội Bài",
 * "Hà Nội", "Phú Quốc") từng bị nhận nhầm là tiếng Việt → tin NV gửi khách Pháp không bao giờ được dịch sang VI cho
 * nhân viên đọc (ca Bernard Orts BC604, 22/10/2026).
 * Quy tắc: ≥1 từ có ký tự riêng VÀ (câu ngắn ≤5 từ — tên riêng/ghi chú ngắn — HOẶC ≥12% số từ có ký tự riêng;
 * tiếng Việt thật thường 30–60%).
 */
export function appearsVietnamese(text: string): boolean {
  const words = text.split(/\s+/).filter(Boolean);
  if (!words.length) return false;
  const strong = words.filter(w => VI_STRONG_CHARS_RE.test(w)).length;
  if (strong === 0) return false;
  return words.length <= 5 || strong / words.length >= 0.12;
}

export function fmtDate(date?: string): string {
  if (!date) return '—';
  const parts = date.split('-');
  if (parts.length !== 3) return date;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function fmtDateShort(date?: string): string {
  if (!date) return '—';
  const parts = date.split('-');
  if (parts.length !== 3) return date;
  return `${parts[2]}/${parts[1]}`;
}

// Mobile-optimized: same year → "20/6", other year → "20/6/25"
export function fmtDateMobile(date?: string): string {
  if (!date) return '—';
  const parts = date.split('-');
  if (parts.length !== 3) return date;
  const [y, m, d] = parts;
  const month = parseInt(m, 10);
  const day = parseInt(d, 10);
  if (y === String(new Date().getFullYear())) return `${day}/${month}`;
  return `${day}/${month}/${y.slice(-2)}`;
}

// ISO datetime hoặc Date → "DD/MM/YYYY HH:mm" theo local timezone
export function fmtDateTimeShort(isoOrDate: string | Date): string {
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (isNaN(d.getTime())) return '?';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function calcNights(checkIn: string, checkOut: string): number {
  const ci = new Date(checkIn);
  const co = new Date(checkOut);
  return Math.max(0, Math.round((co.getTime() - ci.getTime()) / 86400000));
}

export function dateAddDays(date: string, days: number): string {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function currentMonthRange(): { from: string; to: string } {
  const now = new Date();
  const from = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-01`;
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const to = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(lastDay)}`;
  return { from, to };
}

// Giờ xe đưa đón mặc định (datetime-local YYYY-MM-DDTHH:mm):
//  • Đón sân bay (pickup)  = ngày giờ NHẬN phòng (mặc định 14:00).
//  • Tiễn sân bay (dropoff) = ngày giờ TRẢ phòng (mặc định 12:00) − 3 tiếng.
export function defaultTransferDateTime(
  direction: 'pickup' | 'dropoff',
  checkIn?: string, checkInTime?: string,
  checkOut?: string, checkOutTime?: string,
): string {
  const date = direction === 'pickup' ? checkIn : checkOut;
  const time = (direction === 'pickup' ? checkInTime : checkOutTime) || (direction === 'pickup' ? '14:00' : '12:00');
  if (!date || !/^\d{2}:\d{2}/.test(time)) return '';
  const dt = new Date(`${date}T${time.slice(0, 5)}:00`);
  if (isNaN(dt.getTime())) return '';
  if (direction === 'dropoff') dt.setHours(dt.getHours() - 3);
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
}

// ── Number / currency utils ──────────────────────────────

export function fmtVND(amount: number): string {
  return new Intl.NumberFormat('vi-VN').format(Math.round(amount)) + '₫';
}

// Giá tham khảo cho Sale báo khách thuê dài hạn/văn phòng — quy ước báo giá $ (USD), khác giá đêm
// OTA báo bằng đ (fmtVND). Xem app/sale/page.tsx formatSalePrice().
export function fmtUSD(amount: number): string {
  return '$' + new Intl.NumberFormat('en-US').format(Math.round(amount));
}

// ── Text wrapping utils ──────────────────────────────────

// Chèn non-breaking space vào tên địa danh 2 từ hay bị tách dòng xấu khi wrap trong cột hẹp (vd
// party-block nửa trang hợp đồng) — "...Hà" cuối dòng + "Nội" xuống dòng riêng trông rất xấu. Áp
// dụng cho địa chỉ động (building.lessor.address, booking.companyAddress...) — KHÔNG sửa được bằng
// cách gõ tay &nbsp; vào dữ liệu Firestore vì đây là text tự do NV nhập. Bài học Hằng báo qua Zalo
// 2026-09-18 (PLHD "48 Bích Câu, ... TP. Hà" / "Nội" tách 2 dòng).
export function noBreakCityNames(text: string | undefined | null): string {
  if (!text) return '';
  return text.replace(/Hà Nội/g, 'Hà Nội');
}

/** Làm tròn tiền CPDV (chi phí dịch vụ HDDH) về hàng NGHÌN gần nhất.
 *  Đơn giá điện/nước lẻ (vd BC 4.729₫/kWh) → mỗi tháng thu khách dạng chẵn nghìn.
 *  Bước cố định 1.000₫. vd 3.414.338 → 3.414.000; 3.414.620 → 3.415.000.
 *  Dùng tại MỌI điểm tạo/hiển thị serviceCosts.amount (xem docs/hddh-finance.md). */
export function roundCpdv(amount: number): number {
  return Math.round(amount / 1000) * 1000;
}

// ── Money input — format khi đang gõ (live thousand separators) ──
// Dùng cho MỌI ô nhập tiền: input type="text" inputMode="numeric"
//   value={fmtMoneyInput(state)}  onChange e => set(parseMoneyInput(e.target.value))
// '5040000' | 5040000 → '5.040.000'; rỗng / 0 / không có số → ''.
export function fmtMoneyInput(raw: string | number | null | undefined): string {
  const n = parseInt(String(raw ?? '').replace(/\D/g, ''), 10);
  return isNaN(n) || n === 0 ? '' : n.toLocaleString('vi-VN');
}
// '5.040.000' → '5040000' (raw digits — lưu state hoặc Number() khi save).
export function parseMoneyInput(s: string): string {
  return s.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
}

export function fmtVNDShort(amount: number): string {
  if (amount >= 1_000_000) {
    const m = amount / 1_000_000;
    return (Number.isInteger(m) ? m.toString() : m.toFixed(1)) + 'tr';
  }
  if (amount >= 1_000) {
    const k = Math.round(amount / 1_000);
    return k + 'k';
  }
  return amount.toString();
}

// ── Search utils ─────────────────────────────────────────

/** Normalize tiếng Việt có dấu → không dấu, lowercase. Dùng để tìm kiếm không phân biệt dấu. */
export function normalizeSearch(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[đĐ]/g, c => c === 'đ' ? 'd' : 'D')
    .toLowerCase();
}

// ── Firestore utils ──────────────────────────────────────

export function stripUndefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  ) as Partial<T>;
}

/**
 * Mã booking GMS: `GMB-YYMMDD-XXXX` — XXXX là 4 ký tự base36 NGẪU NHIÊN (1.679.616 tổ hợp).
 *
 * ⚠️ TRƯỚC 2026-09-13 mã chạy TUẦN TỰ theo số booking (`GMB-260913-1007`). Bỏ vì hai lý do:
 *  1. **Lộ số liệu kinh doanh**: mã in trên hợp đồng gửi khách/đối tác, nhìn số là biết tenant có
 *     bao nhiêu booking. LeBT nêu 13/09/2026.
 *  2. Hai đường sinh mã đếm KHÁC NHAU (client đếm theo TOÀ, server đếm TỔNG) nên cùng ngày có thể
 *     ra cùng mã; mã lại chính là doc ID nên `setDoc` GHI ĐÈ booking cũ, mất dữ liệu không báo lỗi.
 *     Bỏ đếm là xoá luôn gốc của sự lệch đó.
 *
 * ⚠️ Ngẫu nhiên KHÔNG tự nó đủ — 4 ký tự vẫn có thể đụng nhau (bài toán sinh nhật). Nơi GHI phải
 * kiểm tồn tại và sinh lại: server dùng `nextBookingId()` (lib/booking-id.ts), client tự kiểm bằng
 * `getDoc`. Đừng gọi hàm này rồi `setDoc` thẳng.
 *
 * Dùng Web Crypto (`crypto.getRandomValues`) — có ở CẢ trình duyệt lẫn Node 18+, khác
 * `crypto.randomInt` của GBC vốn chỉ chạy được phía server. KHÔNG dùng `Math.random`: đoán được.
 */
export function genBookingId(): string {
  const now = new Date();
  const yy = String(now.getFullYear()).slice(2);
  const mm = pad(now.getMonth() + 1);
  const dd = pad(now.getDate());
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  const rnd = (buf[0] % 36 ** 4).toString(36).toUpperCase().padStart(4, '0');
  return `GMB-${yy}${mm}${dd}-${rnd}`;
}

// Bỏ định dạng Markdown khỏi text AI trước khi gửi/hiển thị cho khách.
// Haiku đôi khi vẫn chèn bold/code/heading dù prompt cấm → strip bằng code cho chắc.
// Giữ nguyên ký tự đời thường như mã cửa "911911#" (heading chỉ tính '#' đầu dòng).
export function stripMarkdown(s: string): string {
  return s
    .replace(/\*\*([^*]+)\*\*/g, '$1')   // **bold**
    .replace(/__([^_]+)__/g, '$1')        // __bold__
    .replace(/`([^`]+)`/g, '$1')          // `code`
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')   // # heading (đầu dòng)
    .replace(/^\s{0,3}>\s?/gm, '');       // > blockquote
}

// Một số tin nhắn/nội dung cũ lưu unpaired surrogate (emoji hỏng encoding, thường do OTA gửi lệch
// hoặc bị cắt chuỗi giữa 1 cặp surrogate ở đâu đó trước khi lưu) → khi nhét vào prompt gửi Anthropic
// API, JSON body chứa lone surrogate bị từ chối "no low surrogate in string" (400 invalid_request_error).
// DÙNG Ở MỌI NƠI ghép nội dung do người dùng/khách tạo (tin nhắn, KB, ghi chú...) vào prompt AI —
// chuyển ra đây từ lib/kb-analyze-runner.ts (bug thật 2026-09-23: ai-suggest chưa có, lỗi y hệt tái phát).
export function stripLoneSurrogates(s: string): string {
  return s.replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, '');
}

// Bug thật 2026-09-26 (Haiku, tin dịch VI booking BC504): model đôi khi lộ bước tự sửa NGAY TRONG
// câu trả lời — dịch xong 1 bản, rồi tự chèn "Actually, let me correct that:" và dịch lại lần 2
// dính liền, dù prompt đã yêu cầu "Return ONLY the translated text — no explanations". Marker luôn
// ra tiếng Anh (model "nghĩ" bằng Anh dù đang dịch ngôn ngữ khác) → cắt tới NGAY SAU mốc gần nhất,
// đó luôn là bản model tự coi là đúng hơn. Dùng ở MỌI route dịch bằng Haiku (translate-vi, api/translate,
// kb-translate, ai-suggest) — cùng model, cùng lỗ hổng.
const AI_SELF_CORRECTION_MARKERS = [
  /actually,?\s+let me correct(?: (?:that|this))?\s*:?\s*/gi,
  /let me correct (?:that|this)\s*:?\s*/gi,
  /on second thought,?\s*:?\s*/gi,
  /wait,?\s+let me (?:redo|retry|correct)(?: (?:that|this))?\s*:?\s*/gi,
  /let me (?:redo|retry|re-?do) (?:that|this)\s*:?\s*/gi,
];

export function stripAiSelfCorrection(text: string): string {
  let cut = -1;
  for (const re of AI_SELF_CORRECTION_MARKERS) {
    for (const m of text.matchAll(re)) cut = Math.max(cut, m.index! + m[0].length);
  }
  return cut >= 0 ? text.slice(cut).trim() : text;
}

// Link Google Maps cho địa điểm: ưu tiên URL cấu hình tay (pin chính xác),
// fallback tìm theo địa chỉ. null khi không có gì để dẫn đường.
export function googleMapsHref(mapsUrl?: string, address?: string): string | null {
  const u = (mapsUrl || '').trim();
  if (u) return u;
  const a = (address || '').trim();
  if (a) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(a)}`;
  return null;
}

/**
 * Chuyển tên khách thành slug URL-safe cho link đẹp có tên cá nhân.
 * "Stephanie Thong" → "StephanieThong" | "Nguyễn Văn An" → "NguyenVanAn"
 *
 * @param name       - Tên gốc (guestName). Nếu hoàn toàn Latin → dùng luôn.
 * @param latinName  - Phiên âm Latin (guestNameLatin). Dùng khi name chứa ký tự không Latin
 *                     (Hán 李明, Cyrillic, Ả Rập…): portalNameSlug("李明","Li Ming") → "LiMing"
 *                     Nếu name không Latin mà latinName rỗng → trả "" (URL không tên, graceful fallback).
 */
export function portalNameSlug(name: string, latinName?: string): string {
  const effective = hasNonLatin(name) && latinName ? latinName : name;
  return effective
    .normalize('NFD')                      // tách dấu thanh thành combining chars
    .replace(/[̀-ͯ]/g, '')       // xóa dấu (tiếng Việt, EU, v.v.)
    .replace(/[^a-zA-Z0-9 ]/g, '')        // chỉ giữ chữ cái Latin, số, khoảng trắng
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join('');
}

// Bảng màu vòng avatar cố định — liệt kê literal để Tailwind JIT quét thấy (KHÔNG ghép chuỗi
// động kiểu `ring-${x}-500`, Tailwind sẽ không build ra class đó).
const AVATAR_RING_COLORS = [
  'ring-rose-500', 'ring-amber-500', 'ring-emerald-500', 'ring-blue-500', 'ring-violet-500',
  'ring-pink-500', 'ring-cyan-500', 'ring-orange-500', 'ring-lime-500', 'ring-fuchsia-500',
];

/**
 * Vòng màu ổn định theo uid — giúp phân biệt avatar NV nhìn giống nhau bằng mắt (cùng tông ảnh,
 * ảnh nhỏ khó nhìn rõ mặt). Dùng ở mọi nơi hiện avatar NV (Phân việc, card /todos, chip lọc NV)
 * để cùng 1 NV luôn có cùng 1 màu xuyên suốt app.
 */
export function avatarRingColor(uid: string): string {
  let hash = 0;
  for (let i = 0; i < uid.length; i++) hash = Math.trunc(hash * 31 + uid.codePointAt(i)!);
  return AVATAR_RING_COLORS[Math.abs(hash) % AVATAR_RING_COLORS.length];
}
